var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.09,45.04v3.43h2.96v-3.43c0-10.66-8.68-19.34-19.34-19.34S0.38,34.38,0.38,45.04v14.58h2.96V45.04 c0-9.03,7.35-16.38,16.38-16.38S36.09,36.01,36.09,45.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.71,24.04c5.71,0,10.35-4.64,10.35-10.35v-2.96c0-5.71-4.64-10.35-10.35-10.35S9.36,5.03,9.36,10.73v2.96 C9.36,19.4,14.01,24.04,19.71,24.04z M12.32,10.73c0-4.08,3.32-7.39,7.39-7.39s7.39,3.32,7.39,7.39v2.96 c0,4.08-3.32,7.39-7.39,7.39s-7.39-3.32-7.39-7.39V10.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.43,45.11c-3.46,0-6.35,2.45-7.04,5.71H22.17v2.96h2.97v5.75h2.96v-5.75h3.1v5.75h2.96v-5.75H45.4 c0.68,3.26,3.58,5.71,7.04,5.71c3.97,0,7.19-3.23,7.19-7.19S56.4,45.11,52.43,45.11z M52.43,56.54c-2.33,0-4.23-1.9-4.23-4.23 c0-2.33,1.9-4.23,4.23-4.23c2.34,0,4.24,1.9,4.24,4.23C56.67,54.64,54.77,56.54,52.43,56.54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdmin);
export default __webpack_public_path__ + "static/media/icon_admin.42d42fe14a2ff9f823713b94e9c22143.svg";
export { ForwardRef as ReactComponent };